import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { getConfigGraphBaseUrl } from '../services/apiService';
import { getAuthToken } from '../services/authService';
import { gqlErrorHandler } from './clientHelper';
import { store } from '../store';

const httpLink = new HttpLink({ uri: getConfigGraphBaseUrl() });

const authLink = new ApolloLink((operation, forward) => {
  const token = getAuthToken();
  if (token) {
    operation.setContext(({ headers = {} }: { headers?: Record<string, string> }) => ({
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    }));
  }
  return forward ? forward(operation) : (null as any);
});

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  const headers = operation.getContext()?.response?.headers;
  gqlErrorHandler(graphQLErrors, networkError, store, headers);
});

const configClient = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});

export function getConfigClient() {
  return configClient;
}
